import { connect } from 'react-redux';

const defaultMapStateToProps = (state) => {
    return {
        ...state
    };
};
const defaultMapDispatchToProps = (state) => {
    return {};
};

// This feels a little disconnected still.
// I think it might make sense to create a standard mapping between
// actions, reducers and the container creation process.
//
// mapStateToProps, and mapDispatchToProps would wind up being
// wrapped in a bound management class that allows for
// scaling the set of actions and reducers to accomodate
// mapping pairs in a more straight-forward way.
// The trick is to avoid coupling actions to reducers, where coupling a
// reducer to an action is acceptable.
export default function createAppContainer (connectors = {}, App) {
    let {
        mapStateToProps,
        mapDispatchToProps
    } = connectors;

    if (mapStateToProps || mapDispatchToProps) {
        const connectedApp = connect(
            mapStateToProps || defaultMapStateToProps,
            mapDispatchToProps || defaultMapDispatchToProps
        )(App);

        connectedApp.fetchData = App.fetchData;
        return connectedApp;
    }

    return App;
}
